import { useEffect } from "react";

function getSiteUrlFromEnv(): string {
  try {
    const envUrl = (import.meta as Record<string, unknown>).env as Record<string, string> | undefined;
    if (envUrl?.VITE_SITE_URL) {
      return envUrl.VITE_SITE_URL;
    }
  } catch {
    // fall through to default
  }
  return "https://kakobuyspreadsheet.my";
}

const SITE_URL = getSiteUrlFromEnv();

export function useJsonLd(jsonLd: Record<string, unknown>) {
  const jsonString = JSON.stringify(jsonLd);

  useEffect(() => {
    const scriptId = `jsonld-${btoa(encodeURIComponent(jsonString)).slice(0, 32)}`;
    const existing = document.getElementById(scriptId);
    if (existing) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.textContent = jsonString;
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) {
        document.head.removeChild(el);
      }
    };
  }, [jsonString]);
}

export function getSiteUrl(): string {
  return SITE_URL;
}